module.exports = __webpack_public_path__ + "img/symbol_6.93ba92f1.png";